import type { HttpErrorResponse } from '@angular/common/http';

import { createEntityCollectionStore, pipeState } from '@core/ngrx-legacy';
import type { ReferralOfferAssignment } from '@core/referrals-types';

const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<ReferralOfferAssignment>()('ReferralsOfferAssignmentCollection', {
    idSelector: e => e.offer.id,
    customActions: adapter => ({
      fetchOne: (state, payload: { id: number }) =>
        adapter.markAsPending(state, { scope: null, entities: [payload.id] }),
      fetchOneSuccess: (state, payload: { data: ReferralOfferAssignment }) =>
        pipeState(adapter.upsertOne(state, payload.data), next =>
          adapter.markAsLoaded(next, { scope: null, entities: [payload.data.offer.id] }),
        ),
      toggle: (state, payload: { offerId: number; enabled: boolean }) =>
        pipeState(adapter.markAsPending(state, { scope: null, entities: [payload.offerId] })),
      toggleSuccess: (state, payload: { data: Partial<ReferralOfferAssignment> }) =>
        pipeState(adapter.updateOne(state, payload.data), next =>
          adapter.markAsLoaded(next, { scope: null, entities: [payload.data.offer?.id!] }),
        ),
      toggleFailed: (state, payload: { offerId: number; error: HttpErrorResponse }) =>
        adapter.setError(state, payload.error, { scope: null, entities: [payload.offerId] }),
      assignReward: (state, payload: { offerId: number; referralRewardId: number | null }) =>
        pipeState(adapter.markAsPending(state, { scope: null, entities: [payload.offerId] })),
      assignRewardSuccess: (state, payload: { data: Partial<ReferralOfferAssignment> }) =>
        pipeState(adapter.updateOne(state, payload.data), next =>
          adapter.markAsLoaded(next, { scope: null, entities: [payload!.data.offer?.id!] }),
        ),
      assignRewardFailed: (state, payload: { offerId: number; error: HttpErrorResponse }) =>
        adapter.setError(state, payload.error, { scope: null, entities: [payload.offerId] }),
      assignTemplate: (state, payload: { offerId: number; templateId: number | null }) =>
        pipeState(adapter.markAsPending(state, { scope: null, entities: [payload.offerId] })),
      assignTemplateSuccess: (state, payload: { data: Partial<ReferralOfferAssignment> }) => {
        let entity = payload.data;
        entity = { ...entity };
        entity.referralTemplate = entity.referralTemplate ?? null;
        return pipeState(adapter.updateOne(state, entity), next =>
          adapter.markAsLoaded(next, { scope: null, entities: [payload!.data.offer?.id!] }),
        );
      },
      assignTemplateFailed: (state, payload: { id: number; error: HttpErrorResponse }) =>
        adapter.setError(state, payload.error, { scope: null, entities: [payload.id] }),
    }),
  });

export {
  actions as ReferralsOfferAssignmentActions,
  reducer as ReferralsOfferAssignmentReducer,
  selectors as ReferralsOfferAssignmentSelectors,
  namespace as ReferralsOfferAssignmentNamespace,
};
